"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putJobCollectionInformation = void 0;
/**
 * Creates a new collection information record if one doesn't exist, or updates an existing one for the specified job ID.
The request body should contain the collection information fields such as waste types, weights, and quantities collected.

 */
var putJobCollectionInformation = function (instance) {
    return function (id, body, config) {
        return instance.put("/jobs/".concat(id, "/collection-info"), body, config);
    };
};
exports.putJobCollectionInformation = putJobCollectionInformation;
